import { Outlet } from "react-router-dom";
import SiteHeader from "./SiteHeader";
import SiteFooter from "./SiteFooter";
import { ToastProvider } from "./ToastProvider";

export default function SiteLayout() {
  return (
    <ToastProvider>
      <div className="flex min-h-screen flex-col bg-background-50">
        <SiteHeader />
        <main className="flex-1">
          <Outlet />
        </main>
        <SiteFooter />
      </div>
    </ToastProvider>
  );
}